// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1tsy9","emails":"CreateEditClinics_emails__1kfAP","emailTagLabel":"CreateEditClinics_emailTagLabel__rr1Sy"};